import type { Routes } from '@angular/router';

export const BOOSTERS_PRESENTATION_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#modules/boosters/views/restaurant-boosters-presentation-view/restaurant-boosters-presentation-view.component').then(
                (m) => m.RestaurantBoostersPresentationViewComponent
            ),
    },
];
